import axios from 'axios';
import { clearStoredToken, getStoredToken } from './auth';

export const hostname = () => {
  // const hostUrl = 'http://localhost:4000/api/admin';
  const hostUrl = 'https://api-mastertech.codekraftsolutions.com/api/admin';

  return hostUrl;
};
console.log(1);

const api = axios.create({
  baseURL: hostname(),
});

api.interceptors.request.use((config) => {
  const token = getStoredToken();

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      clearStoredToken();
      window.dispatchEvent(new CustomEvent('vin-admin:unauthorized'));
    }

    return Promise.reject(error);
  },
);

export default api;
